import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {KiloMenuPage} from "../kilomenu/kilomenu";
import {KiloPartyPage} from "../kiloparty/kiloparty";
import {KiloStorePage} from "../kilostore/kilostore";
@Component({
  selector: 'page-aboutus',
  templateUrl: 'aboutus.html'
})
export class AboutUsPage implements OnInit {
description:any;
descriptiones:any;
descriptions:any;
  constructor(public aboutusCtrl: NavController) {
	  

  }
  ngOnInit(){
	  this.description = window.localStorage.getItem('description_kilomenus');
	   this.descriptiones = window.localStorage.getItem('description_kilopartys');
	    this.descriptions = window.localStorage.getItem('description_kilostores');
		
  }
kilomenu(cartid)
	{
		window.localStorage.setItem('localid', cartid );
		//window.localStorage.setItem('subcatid', subcat );
		//var xyz = window.localStorage.getItem('localid');
		
		//alert(cartid)
		if(cartid==1)
		{
			//this.navCtrl.push(KiloMenuPage);
			this.aboutusCtrl.setRoot(KiloMenuPage);
		}
		if(cartid==2)
		{
			//this.navCtrl.push(KiloPartyPage);
			this.aboutusCtrl.setRoot(KiloPartyPage);
		}
		if(cartid==3)
		{
			//this.navCtrl.push(KiloStorePage);
			this.aboutusCtrl.setRoot(KiloStorePage);
		}
		
	}
}



// WEBPACK FOOTER //
// ./src/pages/aboutus/aboutus.ts